<template>
  <div>
    <KTCodePreview title="Cấu hình đồng bộ với Affiliate">
      <template v-slot:preview>
        <div>
          <b-table
            :items="syncConfigList"
            :fields="fields"
            bordered
            hover
            :busy="onLoading"
            :per-page="0"
          >
            <template v-slot:table-busy>
              <vcl-table :speed="5" :animate="true" :columns="20"></vcl-table>
            </template>
            <template #cell(index)="row">
              {{ row.index + 1 }}
            </template>
            <template #cell(time)="row">
              {{ formatClientDate(row.item.time) }}
            </template>
          </b-table>
        </div>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { VclTable } from 'vue-content-loading';
import ApiService from '../../../core/services/api.service';
import { formatDate, CLIENT_DATE_TIME } from '@/utils/date';
import { handleError } from '@/utils/common';

export default {
  data() {
    return {
      syncConfigList: [],
      fields: [
        {
          key: 'index',
          label: 'STT',
          thStyle: { textAlign: 'center', width: '10%' },
          tdClass: 'text-center align-middle',
        },
        {
          key: 'key',
          label: 'Key module',
          thStyle: { textAlign: 'center', width: '30%' },
          tdClass: 'text-left align-middle',
        },
        {
          key: 'name',
          label: 'Tên module',
          thStyle: { textAlign: 'center', width: '30%' },
          tdClass: 'text-left align-middle',
        },
        {
          key: 'time',
          label: 'Đồng bộ lần cuối',
          thStyle: { textAlign: 'center', width: '30%' },
          tdClass: 'text-center align-middle',
        },
      ],
      onLoading: false,
    };
  },
  components: {
    KTCodePreview,
    VclTable,
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.onLoading) return;
      this.onLoading = true;
      ApiService.get(`/hrm-sync/config`)
        .then((response) => {
          this.syncConfigList = response.data.data;
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          this.onLoading = false;
        });
    },
    formatClientDate(date) {
      return formatDate(date, CLIENT_DATE_TIME);
    },
  },
};
</script>
